import { fetchData } from "./api";

export const getStaticData = async (sort, key, token) =>
  await fetchData(`/api/${sort}/${key}`, null, {
    token,
  });
